import React from 'react'
import styles from './SearchPopover.module.scss'
import { useNavigate } from 'react-router-dom'

const SearchPopoverZip3Items = React.forwardRef(
  (
    { criteria, onAdd, searchText, visible: isVisible, entity, activeMetros },
    ref
  ) => {
    const history = useNavigate()

    const filteredMetros = activeMetros.filter((metro) => {
      if (
        (metro.label &&
          metro.label.toLowerCase().includes(searchText.toLowerCase()))
       // metro.value.toLowerCase().includes(searchText.toLowerCase())
      ) {
        return metro
      } else {
        return null
      }
    })
    const slicedFilteredMetros = filteredMetros.slice(0, 10)

    return (
      <>
        {slicedFilteredMetros.map((option) => (
          <li
            data-option
            key={option.value}
            onClick={() =>
              (window.location.href = `/${entity}zip3dashboard/${option.geo_parent.toLowerCase()}/zip3/${option.value}`)
            }
            onKeyDown={(event) => {
              const { key, currentTarget } = event
              const next = key === 'ArrowDown'
              const prev = key === 'ArrowUp'

              if (!next && !prev) return

              event.preventDefault()

              const nextFocus =
                currentTarget[
                  next ? 'nextElementSibling' : 'previousElementSibling'
                ]

              if (nextFocus) nextFocus.focus()
            }}
            onKeyPress={({ key }) =>
              key === 'Enter' &&
              (window.location.href = `/${entity}zip3dashboard/${option.geo_parent.toLowerCase()}/zip3/${option.value}`)
            }
            tabIndex={-1}
          >
            <span>
              {option.label}
              {/* ({option.geo_parent}) */}{' '}
              <span style={{ color: '#7D7F81', paddingLeft: '5px' }}>
                {' '}
                ZIP3
              </span>
            </span>
          </li>
        ))}
      </>
    )
  }
)
export default SearchPopoverZip3Items
